import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import { pricingPlans } from '../mock';
import BookingModal from './BookingModal';

const Pricing = () => {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');

  const openBooking = (plan) => {
    setSelectedPlan(plan);
    setBookingOpen(true);
  };

  return (
    <section id="pricing" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading font-bold text-slate-900 text-3xl md:text-4xl">Simple, Transparent Pricing</h2>
          <p className="mt-4 text-slate-500 text-lg">Choose the plan that fits your needs. All plans include our core support services.</p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-7 items-start">
          {pricingPlans.map((plan) => (
            <div
              key={plan.name}
              className={`relative rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 ${
                plan.popular
                  ? 'bg-white border-2 border-blue-600 shadow-2xl shadow-blue-600/10 md:-mt-4'
                  : 'bg-white border border-slate-200 shadow-sm hover:shadow-lg'
              }`}
            >
              {plan.popular && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-xs font-semibold px-4 py-1.5 rounded-full shadow-md">
                  Most Popular
                </span>
              )}
              <h3 className="font-heading font-bold text-slate-900 text-2xl text-center">{plan.name}</h3>
              <div className="mt-4 text-center">
                <span className="font-heading font-extrabold text-slate-900 text-4xl">{plan.price}</span>
                <span className="text-slate-400 text-sm ml-1">{plan.period}</span>
              </div>

              <ul className="mt-8 space-y-3.5">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <span className="mt-0.5 w-5 h-5 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center shrink-0">
                      <Check size={13} strokeWidth={3} />
                    </span>
                    <span className="text-slate-600 text-sm">{f}</span>
                  </li>
                ))}
              </ul>

              <Button
                onClick={() => openBooking(plan.name)}
                className={`w-full mt-8 h-11 rounded-lg font-semibold ${
                  plan.popular ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-slate-900 hover:bg-slate-800 text-white'
                }`}
              >
                Get Started
              </Button>
            </div>
          ))}
        </div>
      </div>
      <BookingModal open={bookingOpen} onOpenChange={setBookingOpen} defaultPlan={selectedPlan} />
    </section>
  );
};

export default Pricing;
